import styled from 'styled-components';
import Navigation from './Navigation';

const Sidebar = ({ className }) => {
  return (
    <S.Sidebar className={className}>
      <Navigation />
    </S.Sidebar>
  );
};

const S = {
  Sidebar: styled.aside`
    background: #fff;
    height: 100%;
    padding-top: 1rem;
  `,
};

export default Sidebar;
